import { Stack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import {
  PAID_LESSON_FEE_STATUS,
  PAID_SPEAKING_FEE_STATUS,
  SUBMITTED_FEEDBACK_STAGE,
} from "../stores/jobs/utils/request";
import BookLessons from "./BookLessons";
import ContactClient from "./ContactClient";

type Props = {
  assignedSupport: any;
  openModal: (action: string) => void;
  onSetSchedule: () => void;
  tutorInfo: any;
  requestStatus: any;
  searchSubject: any;
  requestSLUG: string;
  lessonInfo: any;
  store: any;
  students: Array<any>;
  lostRequest: any;
  canBookLessons: boolean;
  bookingStage: any;
  client: any;
};

const TrackBookingStage = observer(
  ({
    assignedSupport = {},
    openModal = () => {},
    onSetSchedule = () => {},
    tutorInfo = {},
    requestStatus,
    searchSubject,
    requestSLUG,
    lessonInfo,
    store,
    students = [],
    lostRequest,
    canBookLessons,
    bookingStage,
    client = {},
    ...rest
  }: Props) => {
    const clientName = `${client.title} ${client.firstName}`;
    const clientWhatsApp = client.preferredComms?.number;
    const clientHasPaid =
      requestStatus === PAID_SPEAKING_FEE_STATUS ||
      requestStatus === PAID_LESSON_FEE_STATUS;
    const bookLessons =
      requestStatus === PAID_LESSON_FEE_STATUS &&
      bookingStage.current === SUBMITTED_FEEDBACK_STAGE;
    const tutorResponse = store.tutorResponse;

    return (
      <Stack mt={2} spacing={6} {...rest}>
        {!bookLessons && (
          <ContactClient
            id="contact-client"
            students={students}
            clientHasPaid={clientHasPaid}
            lostRequest={lostRequest}
            searchSubject={searchSubject}
            clientName={clientName.trim()}
            clientPhone={client.phone}
            clientWhatsApp={clientWhatsApp}
            openModal={openModal}
            tutorInfo={tutorInfo}
            assignedSupport={assignedSupport}
            requestStatus={requestStatus}
            bookingStage={bookingStage}
          />
        )}

        {bookLessons && (
          <BookLessons
            id="book-lessons"
            openModal={openModal}
            lessonInfo={lessonInfo}
            requestSLUG={requestSLUG}
            onSetSchedule={onSetSchedule}
            tutorResponse={tutorResponse}
            assignedSupport={assignedSupport}
            requestStatus={requestStatus}
            bookingStage={bookingStage}
          />
        )}
      </Stack>
    );
  },
);

export default TrackBookingStage;
